import { useContext } from 'react'
import { ContextoSesion } from '../contexto/ContextoSesion'

export function useSesion() {
  const contexto = useContext(ContextoSesion)
  if (!contexto) {
    throw new Error('useSesion debe usarse dentro de <SesionProvider>')
  }
  return contexto
}
